import clsx from 'clsx';
import { Container, Row, Col, Space, Typography, getTypographyDefaultColor } from '@ag1/ui';
import { SanityKeyed, TabbedCollection } from 'types/studio/studio';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import TabbedCollectionContent from './TabbedCollectionContent/TabbedCollectionContent';
import CustomPortableText from '../PortableText/PortableText';
import styles from './TabbedCollection.module.scss';
import { CommonSectionProps } from '../types';

const TabbedCollectionBlockMarkup = (props: SanityKeyed<TabbedCollection> & CommonSectionProps) => {
  const {
    _key: key,
    _type: sectionType,
    isAGZVariant,
    headline,
    text,
    slides,
    theme,
    padding,
    visibleOnPageLoad
  } = props;

  return (
    <div className={clsx(styles.wrapper, isAGZVariant && styles.agzBg, getThemeCSSClass(theme))}>
      <Container narrow id={key}>
        <Space
          top={{ xxs: 40, s: 60, m: 80, l: 164 }}
          bottom={{ xxs: 40, s: 60, m: 0 }}
          className={clsx(getSectionPaddingClasses(styles, padding))}>
          <Row align={{ xl: 'between' }}>
            <Col span={{ xxs: 12, l: { value: 9, wide: true }, xl: 9 }} className={styles.col_info}>
              {headline && (
                <Typography
                  variant="headlineSans"
                  size="2"
                  component="h2"
                  noPadding
                  color={getTypographyDefaultColor(theme)}
                  className={clsx(styles.headline, getThemeCSSClass(theme))}>
                  {headline}
                </Typography>
              )}
              {text && (
                <Typography
                  variant="portalSubtitle"
                  size="2"
                  noPadding
                  color={getTypographyDefaultColor(theme)}
                  className={clsx(styles.text, getThemeCSSClass(theme))}>
                  <CustomPortableText addAccessibility value={text} />
                </Typography>
              )}
            </Col>
            <Col span={{ xxs: 12 }} className={styles.col_slider}>
              <TabbedCollectionContent
                // @ts-ignore Type mismatch between slides prop and expected items type
                items={slides}
                sectionType={sectionType}
                isAGZVariant={isAGZVariant}
                headline={headline}
                theme={theme}
                visibleOnPageLoad={visibleOnPageLoad}
              />
            </Col>
          </Row>
        </Space>
      </Container>
    </div>
  );
};

export default TabbedCollectionBlockMarkup;
